(() => {
  if (window.DukKlaviyoNewsletterInitialized) return;
  window.DukKlaviyoNewsletterInitialized = true;

  const FORM_SELECTOR = '.js-klaviyo-newsletter';
  const CONFIG_SELECTOR = '.js-klaviyo-newsletter-config';
  const EMAIL_SELECTOR = 'input[name="contact[email]"]';
  const API_URL = 'https://a.klaviyo.com/client/subscriptions';
  const API_REVISION = '2026-07-15';

  const LIST_IDS = {
    de: 'XTQ9RA',
    en: 'TrtsgT',
  };

  const getLocale = (config) => {
    return config?.dataset.locale || document.documentElement.lang || 'en';
  };

  const getListId = (locale) => {
    return String(locale).toLowerCase().startsWith('de')
      ? LIST_IDS.de
      : LIST_IDS.en;
  };

  const getErrorMessage = (locale) => {
    return String(locale).toLowerCase().startsWith('de')
      ? 'Die Anmeldung konnte gerade nicht abgeschlossen werden. Bitte versuche es noch einmal.'
      : 'Your subscription could not be completed. Please try again.';
  };

  const getSuccessMessage = (locale) => {
    return String(locale).toLowerCase().startsWith('de')
      ? 'Wir haben Dir soeben eine E-Mail zur Bestätigung Deiner Anmeldung geschickt. Klicke auf den Bestätigungslink in der E-Mail, um die Anmeldung abzuschließen.'
      : "We've just sent you a confirmation email. Click the link in the email to complete your newsletter subscription.";
  };

  const setSubmitting = (form, submitting) => {
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    submitButton.disabled = submitting;
    submitButton.setAttribute('aria-busy', String(submitting));
  };

  const clearInlineMessages = (form) => {
    form
      .querySelectorAll(
        '.js-klaviyo-newsletter-error, .js-klaviyo-newsletter-success',
      )
      .forEach((element) => element.remove());
  };

  const showInlineError = (form, message) => {
    clearInlineMessages(form);

    const error = document.createElement('p');
    error.className = 'text-sm js-klaviyo-newsletter-error';
    error.setAttribute('role', 'alert');
    error.textContent = message;
    form.append(error);
  };

  const showSuccess = (form, locale) => {
    const success = document.createElement('p');
    success.className = 'text-sm js-klaviyo-newsletter-success';
    success.setAttribute('role', 'status');
    success.setAttribute('aria-live', 'polite');
    success.textContent = getSuccessMessage(locale);

    form.replaceChildren(success);
  };

  const subscribeToKlaviyo = async ({
    email,
    siteId,
    listId,
    locale,
    source,
  }) => {
    const response = await fetch(
      `${API_URL}?company_id=${encodeURIComponent(siteId)}`,
      {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: API_REVISION,
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    locale,
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        }),
      },
    );

    if (!response.ok) {
      const responseText = await response.text().catch(() => '');
      throw new Error(
        `Klaviyo subscription failed with status ${response.status}: ${responseText}`,
      );
    }
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches(FORM_SELECTOR)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (form.dataset.klaviyoSubmitting === 'true') return;

      const config = form.querySelector(CONFIG_SELECTOR);
      const emailInput = form.querySelector(EMAIL_SELECTOR);

      if (!config || !(emailInput instanceof HTMLInputElement)) {
        console.error('Klaviyo newsletter form configuration is missing.');
        return;
      }

      clearInlineMessages(form);

      if (!form.reportValidity()) return;

      const siteId = config.dataset.siteId;
      const locale = getLocale(config);
      const listId = getListId(locale);
      const source = config.dataset.source || 'Shopify newsletter form';
      const email = emailInput.value.trim();

      if (!siteId || !listId || !email) {
        console.error('Klaviyo newsletter configuration is incomplete.');
        showInlineError(form, getErrorMessage(locale));
        return;
      }

      form.dataset.klaviyoSubmitting = 'true';
      setSubmitting(form, true);

      try {
        await subscribeToKlaviyo({
          email,
          siteId,
          listId,
          locale,
          source,
        });

        if (source === 'footer') {
          localStorage.setItem('theme:popup-filled', 'true');
        }

        showSuccess(form, locale);
      } catch (error) {
        console.error(error);
        delete form.dataset.klaviyoSubmitting;
        setSubmitting(form, false);
        showInlineError(form, getErrorMessage(locale));
      }
    },
    { capture: true },
  );
})();
